import {
  SmartSearchProfessional,
  SmartSearchProfessionalData,
} from '../../PatientServices/PatientServices.types'

class SmartSearchAnalysisParam {
  static toPersistence(data: SmartSearchProfessional) {
    return {
      clinicId: data?.clinicId,
      patientId: data?.patientId,
    }
  }
}

class SmartSearchAnalysisData {
  static toDomain(data: SmartSearchProfessionalData) {
    const combinePropertiesWithDescriptions = (
      list: string[],
      source: Record<string, string>,
    ) => {
      return list?.map(property => ({
        property,
        description: source[property] || '',
      }))
    }

    const stringProperties = Object.keys(data).reduce<Record<string, string>>(
      (acc, key) => {
        if (typeof data[key] === 'string') {
          acc[key] = data[key] as string
        }
        return acc
      },
      {},
    )
    return {
      passed: combinePropertiesWithDescriptions(data.passed, stringProperties),
      failed: combinePropertiesWithDescriptions(data.failed, stringProperties),
      skipped: combinePropertiesWithDescriptions(
        data.skipped,
        stringProperties,
      ),
      professionalInfo: data?.professionalInfo,
      filterSearch: data?.filterSearch,
      hasCompensationLink: data?.hasCompensationLink ?? false,
      errorMsg: typeof data === 'string' ? data : '',
      eligible: data?.eligible ?? false,
    }
  }
}

export { SmartSearchAnalysisParam, SmartSearchAnalysisData }
